<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="campus.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="phone">Phone</label>
            <input
                id="phone"
                v-model="campus.phone"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('phone')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('phone') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="email">Email</label>
            <input
                id="email"
                v-model="campus.email"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('email')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('email') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="marathonManagementEmail">
                Marathon management email
            </label>
            <input
                id="marathonManagementEmail"
                v-model="campus.marathonManagementEmail"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('marathonManagementEmail')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('marathonManagementEmail') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="address">Address</label>
            <input
                id="address"
                v-model="campus.address"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('address')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('address') }}
            </div>
        </div>
        <div class="col-12 form-group">
            <label for="logo">Logo</label>
            <media-chooser
                v-model="campus.logoId"
                type="image"
                :error-border="hasError('logoId')"
                id-only
            />
        </div>

        <opening-hours
            v-model="campus.openingHours"
            :validation="validation.campus.openingHours"
            :server-errors="serverErrors"
        />

        <social-media-urls
            v-model="campus.socialMediaUrls"
            :validation="validation.campus.socialMediaUrls"
            :server-errors="serverErrors"
        />
    </div>
</template>

<script>
import OpeningHours from './OpeningHours';
import SocialMediaUrls from '@/components/elements/SocialMediaUrls';

export default {
    components: {
        OpeningHours,
        SocialMediaUrls
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            campus: {}
        };
    },

    watch: {
        campus() {
            this.$emit('input', this.campus);
        }
    },

    created() {
        this.campus = { ...this.value };

        if (!this.editMode) {
            this.campus.openingHours = [];
            this.campus.socialMediaUrls = [];
        }
    },

    methods: {
        hasError(key) {
            return (
                this.validation.campus[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.campus,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
